import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';

@inject('QuestionStore') 
@observer
export default class QuestionItem extends Component {
  constructor(props){
    super(props);
    this.state = { activateQuestion: props.opened, answerText: '' };
  }

  handleSubmit(e, isFaq) {
    const { QuestionStore, item } = this.props;
		e.preventDefault();
    QuestionStore.answerQuestion(item.id, this.state.answerText, isFaq);
	}

  componentDidMount() {
    //if (this.props.opened)
    //  this.refs.answer.focus();
  }

  render() {
    const { QuestionStore, item } = this.props;
    const isValid = this.state.answerText.trim().length > 0;

    return (
      <li className={this.state.activateQuestion ? 'active' : ''}>
        <div className="reply">
          { item.product != null &&
            <h2 className="product-name">{ item.product.name }</h2>
          }
          <h5>{item.sender.name}</h5>

          <h3>{item.question}</h3>

          <section className="container-buttons">

            <button htmlFor="textarea" className="btn-answer" onClick={() => this.setState({ activateQuestion: true }, () => this.refs.answer.focus())}>Responder
              <img src={require('../img/icon-answer.svg')} alt="" className="normal"/>
              <img src={require('../img/icon-answer-hover.svg')} alt="" className="hover"/>
            </button>
          </section>
        </div>

        <div className="answer">
          <h5>Resposta</h5>

          <form>
            <p>
              <textarea
                id="textarea"
                className="message"
                name="message"
                value={this.state.answerText}
                onChange={ev => this.setState({ answerText: ev.target.value })}
                ref="answer">
              </textarea>
            </p>

            { isValid &&
              <div className="buttons-wrapper">
                <button onClick={e => this.handleSubmit(e, false)} className={ QuestionStore.isSending ? 'answer disabled' : 'answer' }>Responder</button>
                <button onClick={e => this.handleSubmit(e, true)} className={ QuestionStore.isSending ? 'answer-faq disabled' : 'answer-faq' }>Responder e colocar nas FAQ</button>
              </div>
            }

            { QuestionStore.errorMessage && (
              <span className="errorMessage">{QuestionStore.errorMessage}</span>
            )}

          </form>
        </div>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/QuestionItem.js